import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import type { LinkAppearance } from '../../../../types'
import { ButtonLink } from '../../../ButtonLink'
import { ArrowDownIcon } from '../../../Icons/Navigational/ArrowDown'
import { TypographyV2 } from '../../../Seatbelt2/Foundations/Typography'
import type { File } from '../ExtendedInfoDownload'
import { Print } from '../Print'
import { getFileSize } from './BasicInfoDownload.utils'
import styles from './styles.module.scss'

export const BasicInfoDownload: FunctionComponent<BasicInfoDownloadProps> = ({
  file,
  url,
  label,
  buttonAppearance,
  className,
}) => {
  const [fileSize, sizeUnit] = getFileSize(file.size)

  return (
    <>
      <div className={classnames(styles.container, className)}>
        <ButtonLink
          href={file.path}
          appearance={buttonAppearance}
          aria-describedby="description"
        >
          <ArrowDownIcon />
          {label}
        </ButtonLink>
        <TypographyV2
          textStyle="sb-text-interface-body-x-small-regular"
          id="description"
        >
          {file.type} ({fileSize} {sizeUnit})
        </TypographyV2>
      </div>

      <Print file={file} url={url} />
    </>
  )
}

///////// IMPLEMENTATION /////////

export type BasicInfoDownloadProps = {
  file: File
  url: string
  label: string
  buttonAppearance: LinkAppearance
  className?: string
}
